module.exports = __webpack_public_path__ + "static/wedding-home-on-macbook-590cbc23494ad7f818a356cf0d7ac44f.gif";